import { AlertTriangle } from 'lucide-react';
import { cn } from '@reflex/ui/lib/utils';

const variantStyles = {
  warning:
    'border-status-accent-orange/30 bg-status-accent-orange/5 [&>[data-slot=callout-icon]]:text-status-accent-orange [&>[data-slot=callout-body]]:text-status-accent-orange',
  error:
    'border-status-error/30 bg-status-error/5 [&>[data-slot=callout-icon]]:text-status-error [&>[data-slot=callout-body]]:text-status-error',
  info: 'border-status-info/30 bg-status-info/5 [&>[data-slot=callout-icon]]:text-status-info [&>[data-slot=callout-body]]:text-status-info',
} as const;

interface CalloutProps {
  icon?: React.ComponentType<{ className?: string }>;
  variant?: keyof typeof variantStyles;
  children: React.ReactNode;
  className?: string;
}

export function Callout({
  icon: Icon = AlertTriangle,
  variant = 'warning',
  children,
  className,
}: CalloutProps) {
  return (
    <div
      data-testid="callout"
      className={cn(
        'flex items-start gap-3 rounded-lg border p-3',
        variantStyles[variant],
        className,
      )}
    >
      <Icon data-slot="callout-icon" className="mt-0.5 h-4 w-4 shrink-0" />
      <div data-slot="callout-body" className="min-w-0">
        {children}
      </div>
    </div>
  );
}
